<script setup lang="ts">
// import PaperIcon from "@/components/icons/PaperIcon.vue";
import DoubleCheckIcon from "@/components/icons/DoubleCheckIcon.vue";
// import AccountSearchOutlineIcon from "@/components/icons/AccountSearchOutlineIcon.vue";
import TaskType from "@/enums/task-type.enum";
import PeopleZoomIcon from "@/components/icons/PeopleZoomIcon.vue";
import TestProIcon from "@/components/icons/TestProIcon.vue";
import ApplicationIcon from "@/components/icons/ApplicationIcon.vue";
import BatteryIcon from "@/components/icons/BatteryIcon.vue";

interface Props {
  type: string;
}

const props = defineProps<Props>();

const computedIcon = computed(() => {
  if (props.type === TaskType.TEST) {
    return ApplicationIcon;
    // return PaperIcon;
  } else if (props.type === TaskType.TEST_PRO) {
    return TestProIcon;
  } else if (props.type === "confirmation") {
    return DoubleCheckIcon;
  } else if (props.type === TaskType.EXPERT) {
    return PeopleZoomIcon;
    // return AccountSearchOutlineIcon;
  } else if (props.type === TaskType.ASSESSMENT) {
    return DoubleCheckIcon;
  } else if (props.type === TaskType.BATTERY) {
    return BatteryIcon;
  }
});
</script>

<template>
  <div :class="['task-icon-wrapper', `task-icon-wrapper_${props.type}`]">
    <component :is="computedIcon" class="task-icon" />
  </div>
</template>

<style lang="scss">
.task-icon {
  width: 14px;
  height: 14px;
  &-wrapper {
    color: #fff;
    border-radius: 5px;
    @include flexCenter;
    width: 28px;
    height: 28px;
    flex-shrink: 0;
    &_test {
      // background-color: $brown;
      background-color: #c5a89c;
    }
    &_test_pro {
      background-color: #788470;
    }
    &_expert {
      background-color: #6d6f71;
    }
    &_assessment {
      background-color: #6D6F71;
    }
    &_battery {
      background-color: transparent;

      .battery-icon {
        width: 100%;
        height: 100%;
        border-radius: 5px;
      }
    }
    &_confirmation {
      background-color: $green;
    }
  }
  &_small {
    width: 12px;
    height: 12px;
  }
}
</style>
